<template>
<div>
    <b-card class="cardboardTop" title="Please tell us as much as posible about this suspect.">
        <b-alert variant="primary" show>
            <font-awesome-icon :icon="['fas', 'info-circle']"></font-awesome-icon>&nbsp;&nbsp;This suspect will not be added until you click the
            <b>'Add suspect'</b> button below
        </b-alert>

        <b-form-group>
            <b-row>
                <b-col cols="12">
                    <span class="npfQuestion">Name:</span>
                    <br>
                    <span class="npfsubquestion">Include as much as possible e.g. Nicknames AKA etc.</span>
                    <b-form-input v-model="Suspect.Name" placeholder="name.."></b-form-input>
                </b-col>
            </b-row>
        </b-form-group>
        <b-form-group>
            <b-row>
                <b-col cols="3" v-on:click="Suspect.Gender = 'Male'">
                    <div class="clickable" v-on:click="Suspect.Gender = 'Male'" v-bind:class="{ npfactive: Suspect.Gender == 'Male', npfnonActive :Suspect.Gender != 'Male' }">
                        <input v-on:click="Suspect.Gender = 'Male'" type="radio" id="maleGendertypesuspect" value="Male" v-model="Suspect.Gender">
                        <label for="maleGendertypesuspect">Male</label>
                    </div>
                </b-col>
                <b-col cols="3" v-on:click="Suspect.Gender = 'Female'">
                    <div class="clickable" v-on:click="Suspect.Gender = 'Female'" v-bind:class="{ npfactive: Suspect.Gender == 'Female', npfnonActive :Suspect.Gender != 'Female' }">
                        <input
              v-on:click="Suspect.Gender = 'Female'"
              type="radio"
              id="FemaleGendertypesuspect"
              value="Female"
              v-model="Suspect.Gender"
            >
                        <label for="FemaleGendertypesuspect">Female</label>
                    </div>
                </b-col>
                <b-col cols="3" v-on:click="Suspect.Gender = 'Other'">
                    <div class="clickable" v-on:click="Suspect.Gender = 'Other'" v-bind:class="{ npfactive: Suspect.Gender == 'Other', npfnonActive :Suspect.Gender != 'Other' }">
                        <input
              v-on:click="Suspect.Gender = 'Other'"
              type="radio"
              id="OtherGendertypesuspect"
              value="Other"
              v-model="Suspect.Gender"
            >
                        <label for="OtherGendertypesuspect">Other</label>
                    </div>
                </b-col>
                <b-col cols="3" v-on:click="Suspect.Gender = 'Dont know'">
                    <div class="clickable" v-on:click="Suspect.Gender = 'Dont know'" v-bind:class="{ npfactive: Suspect.Gender == 'Dont know', npfnonActive :Suspect.Gender != 'Dont know' }">
                        <input
              v-on:click="Suspect.Gender = 'Dont know'"
              type="radio"
              id="DKGendertypesuspect"
              value="Dont know"
              v-model="Suspect.Gender"
            >
                        <label for="DKGendertypesuspect">Don't know</label>
                    </div>
                </b-col>

            </b-row>
        </b-form-group>
        <b-form-group>
            <b-row>
                <b-col cols="6">
                    <span class="npfQuestion">Approximate age:</span>
                    <br>
                    <span class="npfsubquestion">For example 30ish</span>
                    <b-form-input v-model="Suspect.aproxAge" placeholder="approx. age.."></b-form-input>
                </b-col>
                <b-col cols="6">
                    <span class="npfQuestion">Approximate height:</span>
                    <br>
                    <span class="npfsubquestion">For example, 5' 11" or 180cm.</span>
                    <b-form-input v-model="Suspect.aproxHeight" placeholder="approx. height.."></b-form-input>
                </b-col>
            </b-row>
        </b-form-group>
        <b-form-group>
            <b-row>
                <b-col cols="6">
                    <span class="npfQuestion">Build:</span>
                    <br>
                    <span class="npfsubquestion">For example, slim, stocky, etc.</span>
                    <b-form-input v-model="Suspect.build" placeholder="build.."></b-form-input>
                </b-col>
                <b-col cols="6">
                    <span class="npfQuestion">Eye colour:</span>
                    <br>
                    <span class="npfsubquestion">For example, blue, green, etc.</span>
                    <b-form-input v-model="Suspect.eyecolour" placeholder="eye colour.."></b-form-input>
                </b-col>
            </b-row>
        </b-form-group>

        <b-form-group>
            <b-row>
                <b-col cols="6">
                    <span class="npfQuestion">Hair colour:</span>
                    <br>
                    <span class="npfsubquestion">For example, blonde, etc.</span>
                    <b-form-input v-model="Suspect.haircolour" placeholder="Hair Colour.."></b-form-input>
                </b-col>
                <b-col cols="6">
                    <span class="npfQuestion">Hair style:</span>
                    <br>
                    <span class="npfsubquestion">For example, long, shaved, etc.</span>
                    <b-form-input v-model="Suspect.hairstyle" placeholder="hair style.."></b-form-input>
                </b-col>
            </b-row>
        </b-form-group>

        <b-form-group>
            <b-row>
                <b-col cols="12">
                    <label class="npfQuestion">Ethnicity?</label>
                    <b-form-select v-model="Suspect.ethnicity" :options="ethnicity"></b-form-select>
                </b-col>
            </b-row>
        </b-form-group>
        <b-form-group>
            <b-row>
                <b-col cols="12">
                    <span class="npfQuestion">Is there anything else you can tell us about the suspect?</span>
                    <br>
                    <span class="npfsubquestion">You can include information about any distinguishing features like if they had facial hair, tattoos or piercings, any particular accent or anything else that may help identify the suspect.</span>
                    <b-form-textarea v-model="Suspect.OtherDeteails" rows="5" max-rows="12" placeholder="Any other details........."></b-form-textarea>
                </b-col>
            </b-row>
        </b-form-group>

        <b-form-group>
            <b-row>
                <b-col cols="12">
                    <b-button v-on:click="$emit('cancelsuspect')" variant="danger">
                        Cancel
                        <font-awesome-icon :icon="['fas', 'times-circle']"></font-awesome-icon>
                    </b-button>
                    <b-button v-on:click="addchildsuspect()" variant="success">
                        Add Suspect
                        <font-awesome-icon :icon="['fas', 'plus']"></font-awesome-icon>&nbsp;
                        <font-awesome-icon :icon="['fas', 'mask']"></font-awesome-icon>
                    </b-button>
                </b-col>
            </b-row>
        </b-form-group>

    </b-card>
</div>
</template>


<script>
export default {
    data() {
        return {
            Suspect: {
                Name: "",
                Gender: "",
                aproxAge: "",
                aproxHeight: "",
                build: "",
                haircolour: "",
                hairstyle: "",
                eyecolour: "",
                OtherDeteails: "",
                ethnicicty: ""
            },
            ethnicity: [{
                    value: "",
                    text: "*** Please Select ***"
                },
                {
                    value: "A09",
                    text: "Any other Asian background"
                },
                {
                    value: "B09",
                    text: "Any other Black background"
                },
                {
                    value: "O09",
                    text: "Any other ethnic group"
                },
                {
                    value: "M09",
                    text: "Any other mixed background"
                },
                {
                    value: "W09",
                    text: "Any other white background"
                },
                {
                    value: "A2H",
                    text: "Arab"
                },
                {
                    value: "A03",
                    text: "Asian - Bangladeshi"
                },
                {
                    value: "A01",
                    text: "Asian - Indian"
                },
                {
                    value: "A02",
                    text: "Asian - Pakistani"
                },
                {
                    value: "B02",
                    text: "Black African"
                },
                {
                    value: "B01",
                    text: "Black Caribbean"
                },
                {
                    value: "O01",
                    text: "Chinese"
                },
                {
                    value: "G02",
                    text: "Gypsy or Irish Traveller"
                },
                {
                    value: "N03",
                    text: "Prefer not to say"
                },
                {
                    value: "M03",
                    text: "White & Asian"
                },
                {
                    value: "M02",
                    text: "White & Black African"
                },
                {
                    value: "M01",
                    text: "White & Black Caribbean"
                },
                {
                    value: "W01",
                    text: "White British"
                },
                {
                    value: "W02",
                    text: "White Irish"
                }
            ],
            error: false,
            errormessage: []
        };
    },
    methods: {
        addchildsuspect: function () {
            this.error = false;
            this.errormessage = [];

            if (!this.error) {
                this.$emit("addsuspect", this.Suspect);
            } else {
                this.errorMessage();
            }
        }
    }
}
</script>     

<style>

</style>
